import { useEffect, useMemo, useState } from 'react'
import GShell from './GShell.jsx'
import { Title, Card, Pill, Err } from './gui.jsx'
import { DOC_CATEGORIES, watchDocuments, createDocument, deleteDocument } from '../../lib/documents.js'

export default function GDocuments() {
  const [raw, setRaw] = useState({})
  const [f, setF] = useState({ title: '', category: DOC_CATEGORIES[0], fileRef: '', notes: '' })
  const [err, setErr] = useState('')
  useEffect(() => { const off = watchDocuments(setRaw); return () => off() }, [])
  const rows = useMemo(() => Object.values(raw || {}).filter(Boolean).sort((a, b) => (a.title || '').localeCompare(b.title || '')), [raw])
  const add = async () => { setErr(''); try { await createDocument(f); setF({ title: '', category: DOC_CATEGORIES[0], fileRef: '', notes: '' }) } catch (e) { setErr(e?.message || 'Failed') } }
  return (
    <GShell>
      <Title title="Documents" subtitle="Links & references — waivers, receipts, policies." />
      <Card>
        <div className="grid sm:grid-cols-3 gap-2">
          <input className="input" placeholder="Title" value={f.title} onChange={(e) => setF((s) => ({ ...s, title: e.target.value }))} />
          <select className="input" value={f.category} onChange={(e) => setF((s) => ({ ...s, category: e.target.value }))}>{DOC_CATEGORIES.map((c) => <option key={c}>{c}</option>)}</select>
          <input className="input" placeholder="Link / file URL" value={f.fileRef} onChange={(e) => setF((s) => ({ ...s, fileRef: e.target.value }))} />
        </div>
        <input className="input w-full mt-2" placeholder="Notes" value={f.notes} onChange={(e) => setF((s) => ({ ...s, notes: e.target.value }))} />
        <button className="btn-primary text-sm mt-2" onClick={add} disabled={!f.title.trim()}>Add Document</button>
        <Err msg={err} />
      </Card>
      <section className="pb-4 grid md:grid-cols-2 gap-3">
        {rows.length === 0 ? <p className="text-sm text-gray-500">No documents.</p> : rows.map((d) => (
          <Card key={d.id}>
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0"><div className="font-extrabold truncate" style={{ color: 'var(--ge-primary)' }}>{d.title}</div>
                {d.fileRef ? <a href={d.fileRef} target="_blank" rel="noreferrer" className="text-xs underline truncate block" style={{ color: 'var(--ge-primary)' }}>{d.fileRef}</a> : null}
                {d.notes ? <p className="text-xs text-gray-600 mt-0.5">{d.notes}</p> : null}</div>
              <Pill>{d.category}</Pill>
            </div>
            <div className="mt-2 pt-2 border-t text-right" style={{ borderColor: 'rgba(0,0,0,0.06)' }}>
              <button className="btn-ghost text-xs" style={{ color: '#B91C1C' }} onClick={async () => { if (window.confirm('Delete?')) await deleteDocument(d.id) }}>Delete</button>
            </div>
          </Card>
        ))}
      </section>
    </GShell>
  )
}
